module.exports = __webpack_public_path__ + "static/media/Sanaz Hafezi.487af8d4.png";